import { createApp } from 'vue'
import App from './App.vue'

export const mount = (): void => {
    const app = createApp(App)
    app.mount('#vue-share-cart-button')
}
